import { message } from 'hljd'
import 'moment/locale/zh-cn'
import moment from 'moment'
import { configure } from '@core/fetch'
import { SHOP_LOGIN_PATH } from '@constant'
import { getUrlParam, getDeviceKind } from '@core/utils'
import dayjs from 'dayjs'
import weekday from 'dayjs/plugin/weekday'
import localeData from 'dayjs/plugin/localeData'

dayjs.extend(weekday)
dayjs.extend(localeData)
const devicekind = getDeviceKind()

configure({
  config: config => {
    config.headers.devicekind = devicekind
    config.headers.appName = 'web_merchantBackend:local_merchant_React'
    return config
  },
  onError: (RetCode, msg) => {
    if (RetCode === 1) {
      sessionStorage.clear()

      if (getUrlParam('DEBUG') != 1) {
        // eslint-disable-next-line
        if (!__DEBUGGER__) {
          window.location.href = SHOP_LOGIN_PATH
        }
      }

      return
    }

    message.warning(msg)
  },
  onSuccess: (RetCode, msg) => {
    if (msg) {
      message.success(msg)
    }
  }
})

moment.locale('zh-cn')

message.config({
  top: 150
})
